import React from "react";

export interface BackgroundProps {
  children?: React.ReactNode;
  color?: string;
  gradColor?: keyof typeof Gradiant_Colors;
  gradiantColor?: keyof typeof Gradiant_Colors;
  gradient_color?: keyof typeof Gradiant_Colors;
  minHeight?: string | number;
  videoHeight?: number;
  videos?: BreakpointVideos;
  title?: string;
  className?: string;
  images?: BreakpointImages;
  imageUrl?: string;
  disableVideoControls?: boolean;
  iosImagesOnly?: boolean;
  imageGradient?: string;
}

export interface BreakpointImages {
  InfinityL?: string;
  InfinityP?: string;
  mobileL?: string;
  mobileP?: string;
  tabletL?: string;
  tabletP?: string;
}
export interface BreakpointVideos {
  InfinityUrl?: string;
  InfinityPoster?: string;
  mobileUrl?: string;
  mobilePoster?: string;
  tabletUrl?: string;
  tabletPoster?: string;
}

export enum Gradiant_Colors {
  PURPLE_COBOLT_135 = "linear-gradient(135deg,#6A2090,#0D3462)",
  MINT_LIME_135 = "linear-gradient(135deg,#49eedc,#91dc00)",
  COBOLT_BLUE_135 = "linear-gradient(135deg,#0057b8,#009fdb)",
  BLUE_DARK_135 = "linear-gradient(135deg,#21528C,#102641)",
  BLUE_DARK_180 = "linear-gradient(180deg,#21528C,#102641)",
  DARK_BLACK_135 = "linear-gradient(135deg,#102641, #000000)",
  DEBUG = "linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))",
}
